import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { isInBinance } from '@binance/w3w-utils';

/**
 * Hook to detect mobile device and Binance Wallet environment
 *
 * @returns {Object} Detection results
 * @returns {boolean} isMobileDevice - True if on mobile device
 * @returns {boolean} isInBinanceWallet - True if in Binance Wallet app
 * @returns {boolean} shouldShowBinanceButton - True if should show "Open in Binance Wallet" button
 * @returns {boolean} shouldShowConnectWallet - True if should show "Connect Wallet" button
 */
export function useBinanceDetection() {
  const [isInBinanceWallet, setIsInBinanceWallet] = useState(false);
  const [shouldShowBinanceButton, setShouldShowBinanceButton] = useState(false);

  // Mobile detection: small screen OR touch device
  const isMobileScreen = useMediaQuery({ maxWidth: 767 });
  const hasCoarsePointer = useMediaQuery({ query: '(pointer: coarse)' });

  const isMobileDevice = isMobileScreen || hasCoarsePointer;

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    // Check if in Binance Wallet
    const inBinance = isInBinance();
    setIsInBinanceWallet(inBinance);

    // Show "Open in Binance Wallet" button if:
    // 1. On mobile device
    // 2. NOT already in Binance Wallet
    const shouldShow = isMobileDevice && !inBinance;
    setShouldShowBinanceButton(shouldShow);
  }, [isMobileDevice]);

  return {
    isMobileDevice,
    isInBinanceWallet,
    shouldShowBinanceButton,
    // Show "Connect Wallet" button if:
    // 1. On desktop (not mobile), OR
    // 2. In Binance Wallet app (already have access to wallet)
    shouldShowConnectWallet: !isMobileDevice || isInBinanceWallet,
  };
}
